export const SET_AUTH_USER_STATUS = 'SET_AUTH_USER_STATUS'
export const SET_AUTH_USER = 'SET_AUTH_USER'
